module.exports = __webpack_public_path__ + "img/payment-failed.680add2e.svg";